export const StorePickupAddress = () => {
  return (
    <div className="col-sm-6 col-md-12 col-lg-6">
      <div className="placed-order-details">
        <div className="cc-placed-order">
          <p>Store Pick Up Address</p>
          <div className="placed-order-info">
            <address>
              WES Australasia
              <br />
              84-90 Parramatta Road, Summer Hill, <br />
              NSW – 2130
              <br />
              Phone: 02 9797 9866
              <br />
            </address>
          </div>
        </div>
      </div>
    </div>
  );
};
